<template>
  <div style="background-color: white;padding-top:0.88rem;">
    <div class="news-nav" id="news-nav">
      <div class="news-nav-pre cus-pointer" @click="jump('/')">
        首页
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/product')">
        产品中心
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-current">
        {{bigName}}
      </div>
    </div>
    <div class="product">
       <div class="left">
         <img class="wow animate__animated durationTime animate__fadeInUp" :style="{ width: productsDetail.img.w + 'rem' }" :src="require(`@/assets/${productsDetail.img.src}`)">
       </div>
      <div class="right">
        <div class="title wow animate__animated durationTime animate__fadeInUp">{{bigName}}</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp">
          {{productsDetail.desc}}
        </div>
        <div class="icon wow animate__animated durationTime animate__fadeInUp">
          <div class="item" v-for="item in productsDetail.icons">
            <div style="background-color: #FEF100;padding: 0.06rem;display: flex;justify-content: center;align-items: center;border-radius: 0.05rem;margin-right: 0.1rem">
              <img  :src="require(`@/assets/${item.src}`)">
            </div>
            <div class="text">
              {{item.title}}
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import productData from "./productsData.js";

export default {
  name: "partnerDetailSoft",
  data() {
    return {
      productsDetail: null,
      id:null,
      bigName:'',
      name:'',
    };
  },
  //为啥这里进来不是每次执行，在另外一个界面又是每次执行呢？
  // y:路由配置里面，不是每一项都要配置keepAlive:true的，默认不用去配置，当组件需要被缓存时再去配置
  created() {
    this.id=this.$route.query.id === undefined ? "1" : this.$route.query.id;
    this.handleData();
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.id=newVal;
      this.handleData();
    }
  },
  computed: {

  },
  methods: {
    handleData() {
      let  products = productData.filter(v => this.id == v.id)[0];
      this.productsDetail=products.detail;
      this.bigName=products.name;
    },
    handleDetail(id) {
      this.handleData(id);
    },
    goBack() {
      this.$router.go(-1);
    },
    jump(r) {
      this.$router.push({ path: r });
    },
  }
};
</script>
<style  scoped lang="scss">
.product{
  padding: 0.29rem 0 1rem 0rem;
  display: flex;
  .left{
    width: 50%;
    background: #F8FAFE;
    border-radius: 0  0.2rem   0.2rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 0;
  }
  .right{
    width: 50%;
    display: flex;
    padding: 0 2.18rem 0 1rem;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    .title{
      font-weight: 600;
      font-size: 0.34rem;
      color: #333333;
    }
    .desc{
      text-indent: 2em;
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
      line-height: 0.35rem;
      margin-top: 0.2rem;
    }
    .icon{
      margin-top: 0.2rem;
      display: flex;
      flex-wrap: wrap;
      .item{
        display: flex;
        align-items: center;
        background-color: #FFF7EC;
        padding: 0.05rem 0.1rem;
        border-radius: 0.05rem;
        margin-right:0.2rem ;
        margin-top: 0.2rem;
        img{
          height: 0.18rem;
        }
        .text{
          font-weight: 500;
          font-size: 0.16rem;
          color: #3B5377;
        }
      }
    }
  }
}
.news-nav {
  padding: 0.29rem 0 0.29rem 2.18rem;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.news-prev > img,
.news-next > img,
.news-nav > img {
  width: 0.06rem;
  height: 0.12rem;
}
.news-nav > img {
  margin: 0 0.2rem;
}
.news-prev > img {
  margin-right: 0.1rem;
}
.news-next > img {
  margin-left: 0.1rem;
}
.news-nav-pre {
  font-size: 0.16rem;
  font-weight: 400;
  color: #999999;
}
.news-nav-current {
  height: 0.22rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}

</style>



// WEBPACK FOOTER //
// src/pages/product/productDetailSoft.vue